import { locales } from 'core/localization/locales';
import dayjs from 'dayjs';
import i18n from 'i18next';
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

i18n.on('languageChanged', (language: string) => {
  locales[language]().then(() => {
    dayjs.locale(language);
  });
});

i18n
  .use(initReactI18next)
  .use(HttpApi)
  .init({
    returnNull: false,
    debug: false,
    initImmediate: false,
    fallbackLng: ['en', 'ru', 'uk', 'be', 'es'],
    ns: 'translation',
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/{{ns}}/{{lng}}.json',
    },
  });

export default i18n;
